<template>
  <div :class="{'login-layout': true, 'include-inset':includeInset }">
    <!--左侧插图-->
    <div v-if="includeInset" class="login-inset">
      <span class="login-inset-logo"><logo /></span>
      <j-svg-icon name="login-inset" />
      <span class="login-inset-support">技术支持：北京博图纵横科技有限责任公司</span>
    </div>
    <!--右侧内容-->
    <div class="login-box">
      <div v-if="loginAccess" class="login-box-form">
        <div class="login-box-form-title">{{title}}</div>
        <el-form :model="loginForm" :rules="loginFormRule" ref="loginForm" @keydown.native.enter="checkLogin">
          <el-form-item prop="username">
            <j-input prefix-icon="el-icon-user" size="medium" v-model="loginForm.username" placeholder="请输入用户名" @focus="errorText = ''" :maxlength="40" />
          </el-form-item>
          <el-form-item prop="password">
            <j-input prefix-icon="el-icon-unlock" size="medium" v-model="loginForm.password" placeholder="请输入密码" @focus="errorText = ''" type="password" :maxlength="40"/>
          </el-form-item>
          <el-form-item v-if="useValidateCode" prop="validateCode" class="login-box-form-code-content">
            <el-input class="login-box-form-code-input" size="medium" v-model="loginForm.validateCode" placeholder="请输入验证码" @focus="errorText = ''" :maxlength="6" />
            <div class="login-box-form-code"><img :src="base64" alt="验证码" /></div>
            <span class="login-box-form-code-refresh" @click="getValidateCode"><i class="el-icon-refresh-right" style="font-size: 10px;margin-right: 2px;" />换一张</span>
          </el-form-item>
        </el-form>
        <transition name="el-zoom-in-top">
          <div v-if="errorText" class="login-warn-tip common-text-overflow-line2" :title="errorText"><i class="el-icon-warning" />{{errorText}}</div>
        </transition>
        <el-button class="login-box-form-btn" type="primary" @click="checkLogin" :loading="loading">登 录</el-button>
      </div>
      <el-alert v-else title="登录提示" style="height: 350px;width:400px;box-shadow: 0 2px 4px rgba(0, 0, 0, .12), 0 0 6px rgba(0, 0, 0, .04);background-color: rgba(255,255,255,.2);" description="子系统已禁止登录，请前往统一门户登录" :closable="false" center show-icon />
    </div>
  </div>
</template>

<script>
  import encrypt from "../../utils/encrypt/encrypt";
  import { title, loginAccess } from "../../config";
  import JInput from "../../components/JComponents/JInput/JInput";
  import Logo from "@/components/Logo.vue";

  export default {
    name: 'login',
    components: {
      Logo,
      JInput
    },
    data () {
      return {
        title,
        loginAccess,
        base64: '', // 验证码图片
        useValidateCode: false, // 使用验证码
        includeInset: true, // 显示左侧插画
        errorText: '',
        loading: false,
        loginForm: {
          username: '',
          password: '',
          validateCode: '',
          validateCodeToken: ''
        },
        loginFormRule: {
          // username: [{ required: true, message: '请输入用户名', trigger: 'blur' }],
          // password: [{ required: true, message: '请输入密码', trigger: 'blur' }],
          // validateCode: [{ required: true, message: '请输入验证码', trigger: 'blur' }]
        }
      }
    },
    mounted () {
      this.getValidateCode()
    },
    methods: {
      errorHandle (err) {
        // this.$message.error(err.msg || '登录异常')
        this.errorText = err.msg || err.message || '登录异常'
      },
      checkLogin () {
        if (this.loginForm.username == '') return this.errorHandle({msg: '请输入用户名'})
        if (this.loginForm.password == '') return this.errorHandle({msg: '请输入密码'})
        if (this.useValidateCode && this.loginForm.validateCode == '') return this.errorHandle({msg: '请输入验证码'})
        this.login()
      },
      // async checkLogin () {
      //   const isSuccess = await this.$refs.loginForm.validate()
      //   isSuccess && this.login()
      // },
      async login () {
          if (this.loading) return
          this.loading = true
          let loginApi = `/api/admins/login`
          if (this.useValidateCode) loginApi = `/api/admins/login-validate-code`
          const { data } = await this.$http.post(loginApi, {
            ...this.loginForm,
            password: encrypt.getEncryptSM4(this.loginForm.password)
          })
          .catch(({response}) => {
            this.getValidateCode()
            this.errorHandle(response.data)
          })
          .finally(() => { this.loading = false })
          if (data.status != 'yes') {
            this.getValidateCode()
            return this.errorHandle(data)
          }
          this.$store.commit('user', data.data)
          this.$router.push('/')
      },
      async getValidateCode () {
        if (!this.useValidateCode) return
        const { data } = await this.$http.get(`/api/admins/validate-code`)
        if (data.status !== 'yes') return this.$message.error(data.msg || data.message || '验证码获取异常')
        this.base64 = data.data.img
        this.loginForm.validateCodeToken = data.data.validateCodeToken
      }
    }
  }
</script>

<style lang="scss">
  .login-layout {
    min-width: 1000px;
    height: 100%;
    display: flex;
    .login-inset {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      flex: 1.2;
      font-size: 800px;
      /*background-image: url("../../assets/login-inset.png");*/
      overflow: hidden;
      background-color: rgba(236,245,255, .5);
      .login-inset-logo {
        position: absolute;
        display: block;
        color: #dadada;
        font-size: 46px;
        background-repeat: no-repeat;
        background-size: contain;
        top: 40px;
        left: 40px;
      }
      .login-inset-support {
        position: absolute;
        bottom: 24px;
        left: 40px;
        font-size: 14px;
        font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
        font-weight: normal;
        color: rgba(120,132,154,0.5);
        line-height: 20px;
      }
    }
    &.include-inset {
      .login-box {
        justify-content: flex-start;
        padding-left: 50px;
      }
    }
    .login-box {
      flex: 1;
      height: 100%;
      min-width: 200px;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: #ecf5ff;
      /*background-image: url("../../assets/login-bg.png");*/
      background-size: auto 100%;
      .login-box-form {
        width: 280px;
        padding: 40px;
        background-color: #fff;
        border-radius: 10px;
        box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1);
        .login-box-form-title {
          position: relative;
          padding: 0 0 38px;
          font-size: 18px;
          font-weight: bold;
          text-align: center;
          &:after {
            position: absolute;
            bottom: 24px;
            left: 50%;
            content: '';
            width: 32px;
            height: 2px;
            background: #dadada;
            transform: translateX(-50%);
          }
        }
        .login-box-form-code-content {
          margin-bottom: 12px!important;
          .login-box-form-code-input {
              width: 110px;
              .el-input__inner {
                padding: 0 10px;
              }
          }
          .el-form-item__content {
            display: flex;
            align-items: center;
          }
        }
        .login-box-form-code-refresh {
          font-size: 12px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #4378D2;
          line-height: 18px;
          cursor: pointer;
        }
        .login-box-form-code {
          height: 40px;
          width: 86px;
          background-color: #F5F7FA;
          margin: 0 8px;
          > img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .login-box-form-btn {
          width: 100%;
          height: 40px;
          font-size: 16px;
          margin-top: 48px;
          border-radius: 8px;
        }
        .login-warn-tip {
          position: absolute;
          width: 300px;
          font-size: 14px;
          font-family: Alibaba-PuHuiTi-R, Alibaba-PuHuiTi;
          font-weight: normal;
          color: #FF6300;
          line-height: 20px;
          i {
            margin-right: 2px;
          }
        }
      }
    }
  }
</style>
